import * as React from 'react'

import { Button, Time } from '../../components'
import ChartLayout from '../../models/chart_layout'
import { FullscreenButton } from './fullscreen_button'
import { IdeasDropdown } from './ideas_dropdown'
import { ChartLayoutDropdown } from './layout_dropdown'
import { Publish } from './publish'
import { ThemeToggleButton } from './theme_toggle_button'
import { TourButton } from './tour_button'

const BREAKPOINTS = [
  { minWidth: -Infinity, marketBadgeText: false, timeFormat: 'timeOnly' },
  { minWidth: 550, marketBadgeText: false, timeFormat: 'short' },
  { minWidth: 700, marketBadgeText: false, timeFormat: 'long' },
  { minWidth: 768, marketBadgeText: true, timeFormat: 'long' },
]

interface ChartLayoutHeaderProps {
  model: ChartLayout
  onSettingsOpen: () => void
  refreshHeader: () => void
  hasPublish: boolean
}

export function ChartLayoutHeaderComponent({ model, onSettingsOpen = () => {}, hasPublish }: ChartLayoutHeaderProps) {
  return (
    <>
      <div className="flex grow items-center space-x-2">
        <IdeasDropdown model={model} />
      </div>
      <div className="flex grow items-center justify-end space-x-2">
        <TourButton />
        <ChartLayoutDropdown model={model} />
        <FullscreenButton />
        {hasPublish && <Publish model={model} />}
        <ThemeToggleButton model={model} />
        <Button
          appearance="square"
          leftContent="settingsWheel"
          theme="headerItem"
          data-testid="chart-settings-open-btn"
          title="Settings"
          className="settings-button"
          onClick={onSettingsOpen}
        />
        <Time
          id="time"
          breakpointMode="window"
          className="text-[11px] font-medium text-gray-50 lg:text-2xs"
          breakpoints={BREAKPOINTS}
        />
      </div>
    </>
  )
}

export const ChartLayoutHeader = React.memo(
  ChartLayoutHeaderComponent,
  (prevProps, nextProps) =>
    prevProps.model === nextProps.model &&
    prevProps.onSettingsOpen === nextProps.onSettingsOpen &&
    prevProps.hasPublish === nextProps.hasPublish
)
